// src/api/subscribable/SKIP_UPDATE.ts
var SKIP_UPDATE = Symbol("skip-update");
export {
  SKIP_UPDATE
};
//# sourceMappingURL=SKIP_UPDATE.mjs.map